'use client';

import dynamic from 'next/dynamic';
import { Spinner } from '~/components/Spinner';
import drawerStyles from './AlternativeAccommodationDrawer.module.css';

const AlternativeAccommodationMapSheet = dynamic(
  () => import('./AlternativeAccommodationMapSheet').then((mod) => mod.AlternativeAccommodationMapSheet),
  {
    ssr: false,
    loading: () => (
      <div className={drawerStyles.mapLoadingState} aria-busy="true" aria-live="polite">
        <Spinner />
      </div>
    )
  }
);

export { AlternativeAccommodationMapSheet as AlternativeAccommodationMapSheetLazy };
